import { Box, Typography } from '@mui/material';
import { CouponsV2AvailableGiftDTO } from 'probonio-shared-ui/api';
import { useTranslation } from 'react-i18next';
import NavigationButton from '../../../component/button/NavigationButton';
import { GiftMetaLines } from '../../coupons/gift/GiftMetaLines';
import { PresentIcon } from './PresentIcon';

interface Props {
  onClick: () => void;
  gift: CouponsV2AvailableGiftDTO;
}

export const IncentiveNavButton: React.FC<Props> = ({ onClick, gift }) => {
  const { t } = useTranslation('couponsV2Module');

  return (
    <Box
      sx={{
        color: 'primary',
        marginTop: 1,
      }}
    >
      <NavigationButton onClick={onClick} iconRight={null} data-test-id="incentive-button" iconLeft={<PresentIcon fontSize="large" />}>
        <Typography
          variant="h3"
          sx={{
            color: 'text.primary',
          }}
        >
          {t('incentives.buttonTitle')}
        </Typography>
        <Typography
          variant="body2"
          sx={{
            color: 'text.secondary',
          }}
        >
          {t('incentives.buttonSubtitle')}
        </Typography>
        <GiftMetaLines gift={gift} />
      </NavigationButton>
    </Box>
  );
};
